function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import * as React from "react";
import { defaultAddress } from "../../../../components/clients/defaultClient";
import AddressInputs from "./AddressInputs";
import "./address_form.scss";

var AddressForm = function AddressForm(props) {
  var user = props.user,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$onlyOneEmail = props.onlyOneEmail,
      onlyOneEmail = _props$onlyOneEmail === void 0 ? false : _props$onlyOneEmail,
      onChange = props.onChange,
      _props$listRegions = props.listRegions,
      listRegions = _props$listRegions === void 0 ? [] : _props$listRegions,
      _props$listComunas = props.listComunas,
      listComunas = _props$listComunas === void 0 ? [] : _props$listComunas;

  var handleOnChange = function handleOnChange(newAddress, index) {
    // Get adddresses with replaced value
    var newAddresses = user.addresses.map(function (userAddress, indexAddress) {
      if (index === indexAddress) {
        return _objectSpread(_objectSpread({}, userAddress), newAddress);
      }

      return userAddress;
    });
    onChange(_toConsumableArray(newAddresses));
  };

  var handleAddAddress = function handleAddAddress() {
    var newAddress = _toConsumableArray(user.addresses);

    newAddress.push(_objectSpread(_objectSpread({}, defaultAddress), {}, {
      user_id: user === null || user === void 0 ? void 0 : user.id,
      is_main: false
    }));
    onChange(_toConsumableArray(newAddress));
  };

  var handleRemoveAddress = function handleRemoveAddress(index) {
    var newAddress = user.addresses.filter(function (address, index_address) {
      return index_address !== index;
    });
    onChange(_toConsumableArray(newAddress));
  };

  React.useEffect(function () {
    if (!onChange) return;

    if (!user.addresses || user.addresses.length === 0) {
      var prefilledAddress = _objectSpread(_objectSpread({}, defaultAddress), {}, {
        user_id: (user === null || user === void 0 ? void 0 : user.id) || null,
        street: user.street || "",
        region_id: user.region_id || null,
        comuna_id: user.comuna_id || null,
        is_main: true
      });

      onChange([prefilledAddress]);
    }
  }, [user, onChange]);
  return /*#__PURE__*/React.createElement("div", {
    className: "container-fluid row cntAddressForm no-padding"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-12 no-padding"
  }, user.addresses.map(function (address, index) {
    return /*#__PURE__*/React.createElement(AddressInputs, {
      key: index,
      index: index,
      address: address,
      disabled: disabled,
      hideLabel: index > 0,
      disableRemoveButon: index === 0 || disabled,
      onChange: function onChange(newAddress) {
        return handleOnChange(newAddress, index);
      },
      onDelete: function onDelete(index) {
        return handleRemoveAddress(index);
      },
      listRegions: listRegions,
      listComunas: listComunas
    });
  })), !onlyOneEmail && !disabled && /*#__PURE__*/React.createElement("div", {
    className: "col-md-2 buttonPlus no-padding"
  }, /*#__PURE__*/React.createElement("button", {
    className: "btn btn-sm btn-block",
    onClick: handleAddAddress
  }, "+")));
};

export default AddressForm;